<fury-page-layout mode="table">
  <fury-backdrop #backdrop="furyBackdrop"></fury-backdrop>

  <fury-sidebar #furySidebar="furySidebar" [backdrop]="backdrop" position="right">
    <fury-tasks-filters (closed)="furySidebar.close()" (updateFilters)="updateFilters($event)" [clearFilters]="clearFilters" [pageType]="pageType"></fury-tasks-filters>
    <button (click)="furySidebar.close()" class="close-button" mat-icon-button type="button">
      <mat-icon>close</mat-icon>
    </button>
  </fury-sidebar>

  <fury-page-layout-header>
    <fury-breadcrumbs @fadeInRight [crumbs]="['Taken']" current="{{ currentRouteName }}">
    </fury-breadcrumbs>
    <fury-page-header-buttons [buttons]="buttons">
      <ng-container *ngIf="(authenticationService.user$ | async)?.permissions?.includes('tasks.view.deleted')">
        <mat-checkbox (click)="toggleFilter('include_deleted_tasks')" [checked]="skipDeletedTasks" class="mat-dark-grey">
          Weergeven verwijderde taken
        </mat-checkbox>
      </ng-container>
    </fury-page-header-buttons>
  </fury-page-layout-header>
  <fury-page-layout-content @fadeInUp>
    <mat-table (matSortChange)="api.setSort($event)" [dataSource]="dataSource" matSort>
      <ng-container *ngFor="let column of columns" matColumnDef="{{column.name}}">
        <mat-header-cell *matHeaderCellDef [disabled]="column.name === 'actions' || !column.sortable" mat-sort-header>
          <ng-container [ngSwitch]="column.name">
            <ng-container *ngSwitchDefault>
              <div class="header-content">
                {{ column.title }}
              </div>
              <fury-table-filters (clearFilter)="clearFilter(column.name)"
                                  (filterChange)="setFilter(column.name, $event)"
                                  [customFiltering]="true"
                                  [data]="getMatSelectData(column.data)"
                                  [options]="column"
              ></fury-table-filters>
            </ng-container>
          </ng-container>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [style.background-color]="column.name === 'status_id' && row.status?.color ? row.status.color : false">
          <span>
          <ng-container [ngSwitch]="column.name">
            <ng-container *ngSwitchCase="'created_at'">
              <ng-container *ngIf="row.priority && row.priority === 'Hoog'">
                <mat-icon class="red-icon">warning</mat-icon>
              </ng-container>
              {{ row.created_at | date:'dd-MM-yy HH:mm' }}
            </ng-container>
            <ng-container *ngSwitchCase="'number'">
              {{ row.number }}
            </ng-container>
            <ng-container *ngSwitchCase="'basic_registration_id'">
              {{ row.basic_registration?.name }}
            </ng-container>
            <ng-container *ngSwitchCase="'task_registration_id'">
              {{ row.task_registration?.name }}
            </ng-container>
            <ng-container *ngSwitchCase="'location'">
              {{ row.complaint.location ?? 'Onbekend' }}
            </ng-container>
            <ng-container *ngSwitchCase="'assigned_user_id'">
              <ng-container *ngIf="row.assigned_user_id">
              {{ row.assigned_user?.name }}
              </ng-container>
              <ng-container *ngIf="!row.assigned_user_id">
                <mat-icon matTooltip="Task visible to users assigned to tile">info</mat-icon>
                <i>
                {{ getTileAssignedUsers(row.tile_assigned_users) }}
                </i>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'priority_id'">
              {{ row.priority?.display_name }}
            </ng-container>
            <ng-container *ngSwitchCase="'status_id'">
              {{ row.status?.display_name }}
            </ng-container>
            <ng-container *ngSwitchCase="'handled_days'">
    					<span *ngIf="row.handling.handled_days > 0">
    						<span class="handling_days">
    							<span *ngFor="let items of taskService.handlingDaysRange(row.handling.handling_days, row.handling.handled_days); let i = index;"
                        class="days{{i}}"></span>
		    				</span>
    						<span class="handling_text" [class.red]="row?.handling.handled_days > row?.handling.handling_days">
							    {{ row?.handling.handled_days }} dag<span *ngIf="row?.handling.handled_days > 1">en</span>
    						</span>
		    			</span>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ row[column.name] }}
            </ng-container>
          </ng-container>
          </span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="visibleColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: visibleColumns;"
               [class.deleted]="row.is_deleted"
               [class.active]="lastOpenReportId === row.id"
               (click)="lastOpenReportId = row.id"
               [routerLink]="'bekijk/' + row.id"
               class="clickable route-animations-elements"></mat-row>
      <div *matNoDataRow class="mat-row mat-row-no-data">
        <div class="mat-cell">Geen data beschikbaar</div>
      </div>
    </mat-table>

    <mat-paginator (page)="api.setPagination($event)"
                   [length]="api.routeParams.length"
                   [pageSizeOptions]="api.pageSizeOptions"
                   [pageSize]="api.pageSize"
                   matPaginationGoToPageDirective
                   class="table-paginator"></mat-paginator>
  </fury-page-layout-content>
</fury-page-layout>
<router-outlet></router-outlet>
